import Moment from "moment";

export const pdInitialState = {
  certificationsYesCheck: false,
  certificationsNoCheck: false,
  certificationsError: false,
  clu: false,
  cluDate: "",
  cluDateError: false,
  cluDateErrorText: "",
  chfc: false,
  chfcDate: "",
  chfcDateError: false,
  chfcDateErrorText: "",
  msfs: false,
  msfsDate: "",
  msfsDateError: false,
  msfsDateErrorText: "",
  cfp: false,
  cfpDate: "",
  cfpDateError: false,
  cfpDateErrorText: "",
  cic: false,
  cicDate: "",
  cicDateError: false,
  cicDateErrorText: "",
  lutcf: false,
  lutcfDate: "",
  lutcfDateError: false,
  lutcfDateErrorText: "",
  flmi: false,
  flmiDate: "",
  flmiDateError: false,
  flmiDateErrorText: "",
  rhu: false,
  rhuDate: "",
  rhuDateError: false,
  rhuDateErrorText: "",
  msm: false,
  msmDate: "",
  msmDateError: false,
  msmDateErrorText: "",
  ria: false,
  riaDate: "",
  riaDateError: false,
  riaDateErrorText: "",
  jd: false,
  jdDate: "",
  jdDateError: false,
  jdDateErrorText: "",
  pfs: false,
  pfsDate: "",
  pfsDateError: false,
  pfsDateErrorText: "",
  cfa: false,
  cfaDate: "",
  cfaDateError: false,
  cfaDateErrorText: "",
  other: false,
  otherDate: "",
  otherDateError: false,
  otherDateErrorText: "",
  otherProfessionalDesignationName: "",
  otherProfessionalDesignationNameError: false,
  professionalDesignationError: false,
  checkboxHasError: false,
  showBackModal: false,
  isDataFetched: false,
  formHasChanged: false,
  fetchedData: "",
};

export const pdArr = [
  "clu",
  "chfc",
  "msfs",
  "cfp",
  "cic",
  "lutcf",
  "flmi",
  "msm",
  "rhu",
  "ria",
  "jd",
  "pfs",
  "cfa",
  "other",
];

export const pdResetDesignations = (state) => {
  return {
    ...state,
    clu: false,
    cluDate: "",
    cluDateError: false,
    cluDateErrorText: "",
    chfc: false,
    chfcDate: "",
    chfcDateError: false,
    chfcDateErrorText: "",
    msfs: false,
    msfsDate: "",
    msfsDateError: false,
    msfsDateErrorText: "",
    cfp: false,
    cfpDate: "",
    cfpDateError: false,
    cfpDateErrorText: "",
    cic: false,
    cicDate: "",
    cicDateError: false,
    cicDateErrorText: "",
    lutcf: false,
    lutcfDate: "",
    lutcfDateError: false,
    lutcfDateErrorText: "",
    flmi: false,
    flmiDate: "",
    flmiDateError: false,
    flmiDateErrorText: "",
    rhu: false,
    rhuDate: "",
    rhuDateError: false,
    rhuDateErrorText: "",
    msm: false,
    msmDate: "",
    msmDateError: false,
    msmDateErrorText: "",
    ria: false,
    riaDate: "",
    riaDateError: false,
    riaDateErrorText: "",
    jd: false,
    jdDate: "",
    jdDateError: false,
    jdDateErrorText: "",
    pfs: false,
    pfsDate: "",
    pfsDateError: false,
    pfsDateErrorText: "",
    cfa: false,
    cfaDate: "",
    cfaDateError: false,
    cfaDateErrorText: "",
    other: false,
    otherDate: "",
    otherDateError: false,
    otherDateErrorText: "",
    otherProfessionalDesignationName: "",
    otherProfessionalDesignationNameError: false,
    professionalDesignationError: false,
  };
};

export const pdReducer = (state, action) => {
  switch (action.type) {
    case "onChange":
      return {
        ...state,
        [action.fieldName]: action.inputValue,
      };
    case "onCheckChange":
      return {
        ...state,
        [action.fieldName]: action.inputValue,
        professionalDesignationError: false,
      };
    case "onRadioChange":
      let opposite;
      if (action.fieldName.includes("Yes")) {
        opposite = action.fieldName.replace("Yes", "No");
      } else if (action.fieldName.includes("No")) {
        opposite = action.fieldName.replace("No", "Yes");
      }
      return {
        ...state,
        [action.fieldName]: action.inputValue,
        [opposite]: false,
        certificationsError: false,
      };
    case "onBlur":
      return {
        ...state,
        [action.fieldName]: action.hasError,
        [`${action.fieldName}Text`]: action.errorText,
      };
    case "onLoad":
      return {
        ...state,
        fetchedData: action.fetchedData,
        isDataFetched: true,
        certificationsYesCheck: action.hasprofdesignation,
        certificationsNoCheck: !action.hasprofdesignation,
      };
    case "setDesignation":
      return {
        ...state,
        [action.designation]: true,
        [`${action.designation}Date`]: action.designationDate,
      };
    case "setOtherDesignation":
      return {
        ...state,
        other: true,
        otherProfessionalDesignationName: action.otherProfDesName,
        otherDate: action.otherDate,
      };
    case "resetDesignations":
      return pdResetDesignations(state);
    default:
      return state;
  }
};

export const pdInitialStateIA = {
  registrations: {},
  designations: {},
  otherDesignations: [
    { designation: "", date: "", error: false, errorText: "" },
  ],
  isDataFetched: false,
};

const DATE_FORMATS = ["YYYY-MM-DD", "MM/DD/YYYY", "MM/YYYY", "YYYY-MM"];

function formatDate(raw) {
  if (!raw || raw === "Invalid date") return "";
  return Moment(raw, DATE_FORMATS, true).isValid()
    ? Moment(raw, DATE_FORMATS, true).format("MM/YYYY")
    : "";
}

function applyFetchedData(state, fetchedData) {
  let fetched =
    Array.isArray(fetchedData) && fetchedData.length > 0
      ? fetchedData[0]
      : typeof fetchedData === "object" && fetchedData !== null
      ? fetchedData
      : {};

  const registrations = Array.isArray(fetched.registrations)
    ? fetched.registrations.reduce(
        (acc, curr) => {
          const matchingKey = Object.keys(acc).find((key) =>
            acc[key]?.label
              ?.toLowerCase()
              .includes((curr.state || "").toLowerCase())
          );
          if (matchingKey) {
            acc[matchingKey] = {
              ...acc[matchingKey],
              checked: true,
              date: formatDate(curr.date),
            };
          }
          return acc;
        },
        { ...state.registrations }
      )
    : { ...state.registrations };

  const designations = Array.isArray(fetched.designations)
    ? fetched.designations.reduce(
        (acc, curr) => {
          let matchingKey = null;

          if (curr.designationdescription) {
            const m = curr.designationdescription.match(/\(([^)]+)\)\s*$/);
            if (m) {
              const abbr = m[1].toUpperCase();
              matchingKey =
                Object.keys(acc).find(
                  (key) => (acc[key]?.abbr || "").toUpperCase() === abbr
                ) || null;
            }
          }

          if (!matchingKey && curr.state) {
            const m = curr.state.match(/^([A-Za-z]+)\s*-/);
            if (m) {
              const abbr = m[1].toUpperCase();
              matchingKey =
                Object.keys(acc).find(
                  (key) => (acc[key]?.abbr || "").toUpperCase() === abbr
                ) || null;
            }
            if (!matchingKey) {
              matchingKey =
                Object.keys(acc).find((key) =>
                  acc[key]?.label
                    ?.toLowerCase()
                    .includes(curr.state.toLowerCase())
                ) || null;
            }
          }

          if (matchingKey && acc[matchingKey]) {
            const rawDate = curr.dateacquired || curr.date;
            const isPdSourced = curr.source === "PD";
            acc[matchingKey] = {
              ...acc[matchingKey],
              checked: true,
              date: formatDate(rawDate),
              fromPD: isPdSourced,
              dateDisabled: isPdSourced,
              candidatedesignationsid: curr.candidatedesignationsid || "",
            };
          }
          return acc;
        },
        { ...state.designations }
      )
    : { ...state.designations };

  const emptyRow = { designation: "", date: "", error: false, errorText: "" };

  const otherDesignations =
    Array.isArray(fetched.other_designations) &&
    fetched.other_designations.length > 0
      ? [
          ...fetched.other_designations.map((other) => ({
            designation: other.designation || "",
            date: formatDate(other.acquiredDate),
            fromPD: other.source === "PD",
            disabled: other.source === "PD",
            candidatedesignationsid: other.candidatedesignationsid || "",
            error: false,
            errorText: "",
          })),
          emptyRow,
        ]
      : pdInitialStateIA.otherDesignations;

  return { ...state, registrations, designations, otherDesignations, isDataFetched: true };
}

export const pdReducerIA = (state, action) => {
  switch (action.type) {
    case "onBlur": {
      const { fieldName, target, errorText, hasError } = action;

      if (target === "registrations" && state.registrations[fieldName]) {
        return {
          ...state,
          registrations: {
            ...state.registrations,
            [fieldName]: {
              ...state.registrations[fieldName],
              error: hasError,
              errorText: errorText,
            },
          },
        };
      }

      if (target === "designations" && state.designations[fieldName]) {
        return {
          ...state,
          designations: {
            ...state.designations,
            [fieldName]: {
              ...state.designations[fieldName],
              error: hasError,
              errorText: errorText,
            },
          },
        };
      }

      console.warn(`Invalid fieldName or target: ${fieldName}, ${target}`);
      return state;
    }

    case "onChange":
      return {
        ...state,
        [action.fieldName]: action.inputValue,
      };

    case "updateRegistration":
      return {
        ...state,
        registrations: {
          ...state.registrations,
          [action.id]: {
            ...state.registrations[action.id],
            ...action.payload,
          },
        },
      };

    case "updateDesignation":
      return {
        ...state,
        designations: {
          ...state.designations,
          [action.id]: {
            ...state.designations[action.id],
            ...action.payload,
          },
        },
      };

    case "initAndLoad": {
      const regEntries = (action.registrations || []).reduce((acc, item) => {
        acc[item.id] = {
          label: item.label,
          profdesignationid: item.profdesignationid,
          checked: false,
          date: "",
          error: false,
          errorText: "",
        };
        return acc;
      }, {});

      const desEntries = (action.designations || []).reduce((acc, item) => {
        acc[item.id] = {
          label: item.label,
          abbr: item.abbr,
          profdesignationid: item.profdesignationid,
          checked: false,
          date: "",
          error: false,
          errorText: "",
        };
        return acc;
      }, {});

      const stateWithLists = {
        ...state,
        registrations: regEntries,
        designations: desEntries,
      };

      if (action.fetchedData) {
        return applyFetchedData(stateWithLists, action.fetchedData);
      }
      return stateWithLists;
    }

    case "onLoad":
      return applyFetchedData(state, action.fetchedData);

    case "updateOtherDesignation": {
      const updatedOtherDesignations = [...state.otherDesignations];
      updatedOtherDesignations[action.index] = {
        ...updatedOtherDesignations[action.index],
        [action.field]: action.value,
      };
      return {
        ...state,
        otherDesignations: updatedOtherDesignations,
      };
    }

    case "addOtherDesignation":
      return {
        ...state,
        otherDesignations: [
          ...state.otherDesignations,
          { designation: "", date: "", error: false, errorText: "" },
        ],
      };

    case "deleteOtherDesignation":
      return {
        ...state,
        otherDesignations: state.otherDesignations.filter(
          (_, index) => index !== action.index
        ),
      };

    default:
      return state;
  }
};
